module.exports = __webpack_public_path__ + "static/the-answer-e82da123697477f9f174451d1bed3193.png";